'use client'

import { usePathname } from 'next/navigation'
import type { MouseEvent } from 'react'
import { HomeLink } from '@/components/home-link'
import { Button } from '@/components/ui/button'
import { useUnity } from '@/hooks/use-unity'

const CHOOSE_PLAN_SECTION_ID = 'choose-plan-diamond'
const SOEDUCADOR_UNITY_IDS = new Set(['U5071E012', 'UE49C70E1'])

export const GarantirAcessoLink = () => {
  const pathname = usePathname()
  const { unity } = useUnity()
  const isSoeducador = SOEDUCADOR_UNITY_IDS.has(unity?.reference ?? '')
  const isDiamondPage = pathname === '/diamond'
  const diamondHref = isDiamondPage
    ? `/diamond#${CHOOSE_PLAN_SECTION_ID}`
    : '/diamond'

  const handleDiamondClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (!isDiamondPage) {
      return
    }
    e.preventDefault()
    window.history.replaceState(null, '', `#${CHOOSE_PLAN_SECTION_ID}`)
    document.getElementById(CHOOSE_PLAN_SECTION_ID)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  if (isSoeducador) {
    return (
      <>
        <Button asChild className="h-10 lg:hidden" id="register-button">
          <HomeLink href={diamondHref} onClick={handleDiamondClick}>
            Seja Diamond
          </HomeLink>
        </Button>
        <Button
          asChild
          className="hidden h-10 lg:inline-flex"
          id="register-button-desktop"
        >
          <HomeLink href="/conta/novo">Garantir Acesso</HomeLink>
        </Button>
      </>
    )
  }

  const href = isDiamondPage
    ? `/diamond#${CHOOSE_PLAN_SECTION_ID}`
    : '/conta/novo'

  return (
    <Button asChild className="h-10" id="register-button">
      <HomeLink href={href} onClick={handleDiamondClick}>
        Garantir Acesso
      </HomeLink>
    </Button>
  )
}
